<template>
  <div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.inspection_label_inspectionType') || '验货方式'"
          >
            <dict-select
              size="small"
              v-model="formData.inspectionType"
              :body="inspectionTypeParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.inspection_label_inspectionStage') || '验货阶段'"
          >
            <dict-select
              size="small"
              v-model="formData.inspectionStage"
              :body="inspectionStageParams"
              url="/master/common/dict/biz"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.inspection_label_inspectionTime') || '验货时间'"
          >
            <el-date-picker
              v-model="formData.inspectionTime"
              value-format="yyyy-MM-dd"
              type="date"
              style="width:100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('INDEX.inspection_label_inspectionRequirement') || '验货要求'
            "
          >
            <el-input
              v-model="formData.inspectionRequirement"
              type="textarea"
              :autosize="{ minRows: 4 }"
              :maxlength="500"
              show-word-limit
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <BatchTable :orderInspectionCode="orderInspectionCode" />
    </el-form>
  </div>
</template>
<script>
import BatchTable from '../batch-table'
export default {
  components: { BatchTable },
  props: { orderInspectionCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      inspectionTypeParams: { dictType: 'inspectionType' },
      inspectionStageParams: { dictType: 'inspectionStage' },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderInspectionCode) return
      this.$api
        .pendingOrderInspectionDetailApi({
          orderInspectionCode: this.orderInspectionCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
